import defaultApiBackend from './api.js';
import utils from './utils.js';
export default function (options) {
    var _options$danmaku, _options$videoColor;
    var defaultOption = {
        container: options.element || document.getElementsByClassName('mfunsPlayer')[0],
        autoSwitch: false,
        draggable: true,
        theme: '#7b7ff7',
        loop: false,
        listLoop: false,
        userIsLogged: false,
        preload: 'metadata',
        volume: 0.7,
        currentVideo: 0,
        apiBackend: defaultApiBackend,
        video: [],
        mutex: true,
        pickerColors: [
            '#FE0302',
            '#FFFF00',
            '#00CD00',
            '#00FF00',
            '#4E6EF2',
            '#89D5FF',
            '#7B7FF7',
            '#757575',
            '#FFFFFF',
            '#FB7229'
        ],
        pluginOptions: {
            hls: {},
            flv: {},
            dash: {},
            webtorrent: {}
        },
        mode: 'web'
    };
    options = Object.assign(defaultOption, options);
    options.danmaku = Object.assign({
        api: '',
        margin: 5,
        opacity: 1,
        shields: [],
        limitArea: 4,
        fontScale: 1,
        speed: 1,
        editor: 1,
        keepOutSubtitle: false,
        showDanmaku: true
    }, (_options$danmaku = options.danmaku) !== null && _options$danmaku !== void 0 ? _options$danmaku : {});
    options.videoColor = Object.assign({
        brightness: 1,
        saturate: 1,
        contrast: 1,
        hueRotate: 0
    }, (_options$videoColor = options.videoColor) !== null && _options$videoColor !== void 0 ? _options$videoColor : {});
    return options;
};